import { render, staticRenderFns } from "./AddNewTier.vue?vue&type=template&id=fbfa5ff8&"
import script from "./AddNewTier.vue?vue&type=script&lang=js&"
export * from "./AddNewTier.vue?vue&type=script&lang=js&"
import style0 from "./AddNewTier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports